import { Reducer } from 'redux';
import { ACTION_TYPES, State } from './types';

const initialState: State<{}> = {
  data: {},
  error: '',
  axiosError: null,
  pending: true,
};

const reducer: Reducer<any, any> = (state = initialState, action): any => {
  const map: any = {
    [ACTION_TYPES.PENDING]: () => ({
      ...state,
      pending: true,
    }),

    [ACTION_TYPES.SUCCESS]: () => ({
      ...state,
      pending: false,
      data: action.payload,
    }),

    [ACTION_TYPES.ERROR]: () => ({
      ...state,
      pending: false,
      error: action.payload,
    }),

    [ACTION_TYPES.RESET]: () => ({
      ...initialState,
    }),

    [ACTION_TYPES.REMOVE_ADMIN]: () => ({
      ...state,
      data: {
        ...state.data,
        availableAdmins: state.data.availableAdmins.filter((admin: any) => admin.name !== action.payload),
      },
    }),
  };

  return typeof map[action.type] === 'function' ? map[action.type]() : state;
};

export default reducer;
